import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../store'; // typed dispatch already inside
import {
  fetchAllChatBookings,
  fetchBetweenDates,
  markAsViewed,
} from '../../store/slices/chatBookingSlice';
import { chatBookingEndpoints } from '../../services/api/endpoints/chat_bookings.endpoints';
import { ChatSearchResponse, ChatType } from '../../types/chat_booking';
import { useState } from 'react';

export interface SearchOptions {
  searchTerm: string;
  startDate: string;
  endDate: string;
}

export interface FetchBetweenOptions {
  startDate: string;
  endDate: string;
  chatType?: ChatType | null;
  page?: number;
  pageSize?: number;
}

export const useChatBookingLogs = () => {
  const dispatch = useDispatch<AppDispatch>();
  const [isSearching, setIsSearching] = useState(false);
  const [searchResults, setSearchResults] = useState<ChatSearchResponse | null>(null);

  const selectedOrgId = useSelector(
    (state: RootState) => state.organizationContext.selectedOrganizationId
  );

  const { chatLogs, unreadCount, page, pageSize, total, totalPages, isLoading, error } =
    useSelector((state: RootState) => state.chatBookingLogs);

  const fetchAll = (pageNum = 1, size = 10, isVoice?: boolean) => {
    if (!selectedOrgId) return;
    console.log('slice 1');
    dispatch(
      fetchAllChatBookings({ orgId: selectedOrgId, page: pageNum, pageSize: size, isVoice })
    );
    console.log('slice 2');
  };

  const refetch = () => {
    console.log('slice 3');
    fetchAll(page, pageSize);
    console.log('slice 4');
  };

  const fetchBetween = ({
    startDate,
    endDate,
    chatType,
    page: p = 1,
    pageSize: s = 10,
  }: FetchBetweenOptions) => {
    if (!selectedOrgId) return;
    dispatch(
      fetchBetweenDates({
        orgId: selectedOrgId,
        startDate,
        endDate,
        chatType,
        page: p,
        pageSize: s,
      })
    );
  };

  const updateViewed = async (chatLogId: string) => {
    if (!selectedOrgId) return;
    await chatBookingEndpoints.updateChatLogBookingViewedStatus(selectedOrgId, chatLogId, {
      isViewed: true,
    });
    fetchAll(page, pageSize);
  };

  const fetchById = (chatLogId: string) =>
    selectedOrgId ? chatBookingEndpoints.getChatLogBookingById(selectedOrgId, chatLogId) : null;

  const search = async ({ searchTerm, startDate, endDate }: SearchOptions) => {
    if (!selectedOrgId) return null;

    setIsSearching(true);
    try {
      const res = await chatBookingEndpoints.searchChatLogs(
        selectedOrgId,
        searchTerm,
        startDate,
        endDate
      );
      setSearchResults(res);
    } finally {
      setIsSearching(false);
    }
  };
  const resetSearch = () => {
    setSearchResults(null);
    fetchAll(1, 10);
  };

  return {
    chatLogs,
    unreadCount,
    page,
    pageSize,
    total,
    totalPages,
    isLoading,
    error,

    fetchAll,
    refetch,
    fetchBetween,
    updateViewed,
    fetchById,
    isSearching,
    search,
    searchResults,
    resetSearch,
  };
};
